import React from 'react'
import CopyToClipboard from '../../../../utils/copy-to-clipboard'

const TransactionId = ({ value }) => {
  return <CopyToClipboard text={value}>{value}</CopyToClipboard>
}
export default TransactionId
